<template>
  <div>
    <!-- 业务页签账单详情弹出框 -->
    <el-dialog
      id="operateApp"
      v-el-drag-dialog
      :visible.sync="innerVisible"
      :title="$t('CargoMsg.Cargo_DomesticBill')"
      :fullscreen="true"
      width="auto"
      :close-on-press-escape="false"
      :modal-append-to-body="false"
      :close-on-click-modal="false"
      class="bill-dialog"
    >
      <div :style="'min-width: 1600px;' + (expandedGrid ? 'height: 100%;display: flex;flex-direction: column;' : '')">
        <!--账单详情表单-->
        <div v-show="!expandedGrid" class="app-main-inner-row bill-dialog-form-wrapper">
          <el-form class="bill-form-content" label-position="left" :label-width="isZh ? '85px' : '135px'" :model="billing">
            <el-row :gutter="5" type="flex">
              <el-col :span="8" style="width: 630px;">
                <div class="section" style="flex:1;height: 100%">
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_BillNo')">
                      <el-input v-model="billing.billingNo" :disabled="true" no="billingNo" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_SettleAccountsTo')">
                      <cargo-advance-select
                        filterable
                        no="settlement"
                        :select-type="selectTypeNames.basic_data_Company"
                        :method-params="{ customer:true, active:true }"
                        :tag-name="isZh ? 'chineseName' : 'englishName'"
                        :default-value="billing.accountId"
                        :clearable="false"
                        @parentCallBack="accountChange"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_SettlementAgent')">
                      <cargo-advance-select
                        filterable
                        no="settlementAgent"
                        :select-type="selectTypeNames.basic_data_Company"
                        :default-value="billing.settlementAgentId"
                        :disabled="accountDisable"
                        :method-params="{'auto_accountId': true}"
                        :cache="false"
                        :clearable="false"
                        :tag-name="isZh ? 'chineseName' : 'englishName'"
                        :static-options="settlementAgentArray"
                        @parentCallBack="settlementAgentChange"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoiceHeader')">
                      <cargo-advance-select
                        :select-type="selectTypeNames.static_data_Title"
                        no="invoiceTitleUuid"
                        :allow-create="!config.arSettlementUnitOptional"
                        filterable
                        :cache="false"
                        :default-value="billing.invoiceTitleUuid"
                        :disabled="accountDisable"
                        tag-value="uuid"
                        :static-options="titleArray"
                        @parentCallBack="titleChangeEvent"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('Partners.CustomerMailbox')">
                      <el-input v-model="billing.customerEmail" :disabled="accountDisable" no="customerEmail" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_RegistrationAddress')">
                      <el-input v-model="billing.buyerAddress" no="buyerAddress" />
                    </el-form-item>
                  </el-col>
                  <el-col class="inline">
                    <el-form-item :label="$t('CargoMsg.Cargo_RegistrationNumber')">
                      <el-input v-model="billing.buyerTaxAccount" :disabled="true" no="buyerTaxAccount" />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_Tel')">
                      <el-input v-model="billing.buyerTelephone" no="buyerTelephone" />
                    </el-form-item>
                  </el-col>
                  <el-col class="inline">
                    <el-form-item :label="$t('CargoMsg.Cargo_DepositBank')">
                      <cargo-advance-select
                        filterable
                        :select-type="selectTypeNames.static_data_TitleBank"
                        no="titleBankUuid"
                        :default-value="billing.titleBankUuid"
                        :cache="false"
                        tag-value="uuid"
                        :static-options="titleBankArray"
                        @parentCallBack="getBankCusFromChild"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber')">
                      <el-input v-model="billing.buyerBankAccount" :disabled="true" no="buyerBankAccount" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_RevenueAndExpenditureType')">
                      <el-input :disabled="true" no="ar" :value="billing.arValue" />
                    </el-form-item>
                  </el-col>
                  <el-col class="inline">
                    <el-form-item :label="$t('CargoMsg.Cargo_OwnerBankOfDeposit')">
                      <cargo-advance-select
                        filterable
                        :cache="false"
                        no="bankAccountId"
                        :select-type="selectTypeNames.static_data_BankAccount"
                        :default-value="billing.bankAccountId === 0 ? '' : billing.bankAccountId"
                        :static-options="ourBankAccountArray"
                        @parentCallBack="getOurBankAccountFromChild"
                      />
                    </el-form-item>
                    <el-form-item :label="$t('CargoMsg.Cargo_AccountNumber')">
                      <el-input v-model="billing.bankAccount" :disabled="true" no="bankAccount" />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_BillDate')">
                      <el-date-picker
                        v-model="billing.inputDate"
                        no="inputDate"
                        type="date"
                        :clearable="false"
                        style="width: 100%"
                        :editable="false"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                        @change="inputDateChange"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_DueDate')">
                      <el-date-picker
                        v-model="billing.dueDate"
                        no="dueDate"
                        type="date"
                        :clearable="false"
                        style="width: 100%"
                        :editable="false"
                        format="yyyy-MM-dd"
                        value-format="yyyy-MM-dd"
                      />
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('CargoMsg.Cargo_AgentBillNo')">
                      <el-input v-model="billing.counterPartyBillingNo" no="counterPartyBillingNo" />
                    </el-form-item>
                  </el-col>
                  <el-col v-show="!billingNoteContainInvoice">
                    <el-form-item :label="$t('Invoice.invoice_invoiceCategory')">
                      <el-select v-model="billing.invoiceMakeType" no="invoiceMakeType" :placeholder="$t('CargoMsg.Cargo_PleaseSelect')" clearable @change="changeInvoiceMakeType">
                        <el-option v-for="(item,index) in invoiceMakeTypes" :key="index" :label="item.chineseName" :value="item.code" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-show="!billingNoteContainInvoice">
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoiceType')">
                      <el-select v-model="billing.invoiceType" no="invoiceType" :placeholder="$t('CargoMsg.Cargo_PleaseSelect')" clearable>
                        <el-option v-for="(item,index) in invoiceTypes" :key="index" :label="item.chineseName" :value="item.code" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col>
                    <el-form-item :label="$t('Billing.billingJob_settlementType')">
                      <el-select v-model="billing.settlementType" no="settlementType" :disabled="accountDisable">
                        <el-option v-if="billing.settlementType === 0" :key="-1" label=" " :value="0" />
                        <el-option v-for="(item,index) in SETTLEMENT_TYPE_STATES" :key="index" :label="$store.getters.isZh ? item.chineseName : item.englishName" :value="item.code" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="config.billingNoteContainInvoiceReques">
                    <el-form-item :label="$t('CargoMsg.Cargo_InvoicingType')">
                      <el-select v-model="billing.makeInvoiceType" no="makeInvoiceType" :disabled="accountDisable" placeholder="" @change="makeInvoiceTypeChange">
                        <el-option :label="$t('CargoMsg.Cargo_LotteryDraw')" :value="0" />
                        <el-option :label="$t('CargoMsg.Cargo_SchoolMonth')" :value="1" />
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col v-if="billingNoteContainInvoice">
                    <el-checkbox v-model="billing.detailMakeInvoice" @change="detailMakeInvoiceChange">{{ $t('CargoMsg.Cargo_DetailMakeInvoice') }}</el-checkbox>
                    <el-checkbox v-model="billing.splitMakeInvoice">{{ $t('CargoMsg.Cargo_SplitMakeInvoice') }}</el-checkbox>
                  </el-col>
                  <el-col v-if="billingNoteContainInvoice && !billing.detailMakeInvoice">
                    <cargo-ag-grid
                      :grid-params.sync="invoiceGoodsName.gridParams"
                      :grid-options="invoiceGoodsName.gridOptions"
                      :column-defs="invoiceGoodsNameColumnDefs"
                      :row-data="billing.billingBeforehandVOS"
                      min-height="100px"
                      style="width:100%;height:100px"
                      @gridReady="params=>invoiceGoodsName.gridApi=params.api"
                    />
                  </el-col>
                </div>
              </el-col>
              <el-col :span="16" style="flex:1">
                <div class="section" style="flex:1;height: 100%">
                  <div>
                    <el-col :span="10" style="width: 550px;">
                      <el-col>
                        <el-col :span="8">{{ $t('CargoMsg.Cargo_OriginalCurrency2') }}</el-col>
                        <el-col :span="8">{{ $t('CargoMsg.Cargo_Amount') }}</el-col>
                        <el-col :span="8">{{ $t('CargoMsg.Cargo_ExchangeRate2') }}</el-col>
                      </el-col>
                      <el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <el-input v-model="billing.sourceCurrency1" :disabled="true" no="sourceCurrency1" style="width: 100px;" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <el-input-number
                              v-model="billing.amount1"
                              no="amount1"
                              controls-position="right"
                              :min="-999999999999"
                              :max="999999999999"
                              :precision="2"
                              :disabled="true"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <num-input
                              v-model="billing.sourceRate1"
                              no="sourceRate1"
                              :min="0"
                              :max="999999999"
                              :precision="8"
                              :truncated-precision="sourceRate1Precision"
                              :disabled="formParams.sourceRate1Enable"
                              @change="calculateAmount"
                            />
                          </el-form-item>
                        </el-col>
                      </el-col>
                      <el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <el-input v-model="billing.sourceCurrency2" no="sourceCurrency2" :disabled="true" style="width: 100px;" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <el-input-number
                              v-model="billing.amount2"
                              no="amount2"
                              controls-position="right"
                              :min="-999999999999"
                              :max="999999999999"
                              :precision="2"
                              :disabled="true"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <num-input
                              v-model="billing.sourceRate2"
                              no="sourceRate2"
                              :min="0"
                              :max="999999999"
                              :precision="8"
                              :truncated-precision="sourceRate2Precision"
                              :disabled="formParams.sourceRate2Enable"
                              @change="calculateAmount"
                            />
                          </el-form-item>
                        </el-col>
                      </el-col>
                      <el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <el-input v-model="billing.sourceCurrency3" :disabled="true" no="sourceCurrency3" style="width: 100px;" />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <el-input-number
                              v-model="billing.amount3"
                              no="amount3"
                              controls-position="right"
                              :min="-999999999999"
                              :max="999999999999"
                              :precision="2"
                              :disabled="true"
                            />
                          </el-form-item>
                        </el-col>
                        <el-col :span="8">
                          <el-form-item label-width="0">
                            <num-input
                              v-model="billing.sourceRate3"
                              no="sourceRate3"
                              :min="0"
                              :max="999999999"
                              :precision="8"
                              :truncated-precision="sourceRate3Precision"
                              :disabled="formParams.sourceRate3Enable"
                              @change="calculateAmount"
                            />
                          </el-form-item>
                        </el-col>
                      </el-col>
                    </el-col>
                    <el-col :span="6">
                      <el-col>
                        <el-form-item :label="$t('CargoMsg.Cargo_BillingCurrency')">
                          <cargo-advance-select
                            filterable
                            :select-type="selectTypeNames.basic_data_Currency"
                            no="currency"
                            :default-value="billing.currency"
                            :clearable="false"
                            @parentCallBack="currencyChangeEvent"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <el-form-item :label="$t('Billing.billingForm_taxAmount')">
                          <el-input-number
                            v-model="billing.amount"
                            no="amount"
                            controls-position="right"
                            :min="-999999999999"
                            :max="999999999999"
                            style="width:100%;"
                            :precision="2"
                            :disabled="true"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col>
                        <el-form-item :label="$t('Billing.billingForm_taxFreeAmount')">
                          <el-input-number
                            v-model="billing.taxFreeAmount"
                            no="taxFreeAmount"
                            controls-position="right"
                            :min="-999999999999"
                            :max="999999999999"
                            style="width:100%;"
                            :precision="2"
                            :disabled="true"
                          />
                        </el-form-item>
                      </el-col>
                    </el-col>
                    <el-col>
                      <el-form-item label-width="0">
                        <span>{{ $t('CargoMsg.Cargo_Remarks') }}</span>
                        <el-input v-model="billing.remark" type="textarea" no="remark" :rows="6" />
                      </el-form-item>
                    </el-col>
                    <el-col>
                      <el-col :span="8">
                        <el-form-item :label="$t('CargoMsg.Cargo_AccountContacts')" label-width="105px;">
                          <cargo-advance-select
                            :select-type="selectTypeNames.static_data_Contact"
                            :allow-create="true"
                            no="accountContacts"
                            filterable
                            :cache="false"
                            clearable
                            style="width: 200px;"
                            :default-value="billing.accountContacts"
                            :static-options="accountContactsArray"
                            @parentCallBack="accountContactChangeEvent"
                          />
                        </el-form-item>
                      </el-col>
                      <el-col :span="6">
                        <el-form-item :label="$t('CargoMsg.Cargo_AccountContactsTel')">
                          <el-input v-model="billing.accountContactsTel" no="accountContactsTel" style="width: 100%;" />
                        </el-form-item>
                      </el-col>
                      <el-col :span="8">
                        <el-form-item :label="$t('CargoMsg.Cargo_AccountAddr')">
                          <el-input v-model="billing.accountAddr" no="accountAddr" style="width: 100%;" />
                        </el-form-item>
                      </el-col>
                    </el-col>
                    <el-col>
                      <el-form-item label-width="0">
                        <span>{{ $t('CargoMsg.Cargo_InvoicingRequirements') }}</span>
                        <el-input v-model="billing.invoiceDemand" type="textarea" no="invoiceDemand" :rows="6" />
                      </el-form-item>
                    </el-col>
                    <el-col v-if="billingNoteContainInvoice">
                      <div style="display: flex; width: 100%;padding-top: 10px">
                        <div style="width: 50%;padding-right: 5px">
                          <span>{{ $t('Invoice.invoice_invoiceRemarks') }}</span>
                          <el-input v-model="billing.invoiceRemark" type="textarea" no="invoiceRemark" :rows="6" :disabled="!billingNoteContainInvoiceChannel" />
                        </div>
                        <div style="width: 50%">
                          <span>{{ billingNoteContainInvoiceChannel ?$t('CargoMsg.Cargo_RemarkAddContent3'): $t('CargoMsg.Cargo_RemarkAddContent') }}</span>
                          <el-input v-model="billing.remarkAddContent" type="textarea" no="remarkAddContent" :rows="6" :disabled="billingNoteContainInvoiceChannel" />
                        </div>
                      </div>
                    </el-col>
                  </div>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="app-main-inner-row" style="justify-content: center;font-size:30px;">
          <i :class="expandedGrid?'el-icon-caret-bottom':'el-icon-caret-top'" @click="expandedGrid=!expandedGrid" />
        </div>
        <div class="app-main-inner-row" style="justify-content: space-between">
          <div>
            <el-button type="primary" @click="copyChargeHandler">{{ this.$t('FinanceManage.charge_copyCharge') }}</el-button>
            <el-button type="primary" @click="schemeBillChargeEvent">{{ this.$t('FinanceManage.charge_sp7') }}</el-button>
            <el-button type="primary" @click="addBillChargeEvent">{{ this.$t('SeaExport.AddCharges') }}</el-button>
            <el-button type="primary" @click="joinBillChargeEvent">{{ this.$t('SeaExport.AddBillCharge') }}</el-button>
            <el-button type="danger" @click="removeBillChargeEvent">{{ this.$t('SeaExport.RemoveBillCharge') }}</el-button>
          </div>
        </div>
        <div class="app-main-inner-row row-grid" :style="expandedGrid?'flex-grow: 1;':'height:300px'">
          <cargo-ag-grid
            :config-module="'1301254'"
            :grid-options="gridOptions"
            :column-defs="columnDefs"
            :row-data="rowData"
            :style="{width:'100%',height:'auto'}"
            @gridReady="params=>{gridApi=params.api}"
          />
        </div>
      </div>
      <div slot="footer">
        <el-button type="primary" @click="saveBilling()">{{ $t('CargoMsg.Cargo_SaveGenerateBills') }}</el-button>
        <el-button type="primary" @click="saveCharges()">{{ $t('CargoMsg.Cargo_GenerateExpensesOnly') }}</el-button>
        <el-button @click="closeDialog()">{{ $t('SeaExport.Cancel') }}</el-button>
      </div>
    </el-dialog>

    <!-- 多条业务 配置规则验证弹窗 -->
    <batch-checking-window
      v-if="batchCheckingWindow.visible"
      :visible.sync="batchCheckingWindow.visible"
      :lob="batchCheckingWindow.lob"
      :jobs="batchCheckingWindow.jobs"
      :check-node="batchCheckingWindow.checkNode"
      :call-back="batchCheckingWindow.callBack"
      :call-back2="batchCheckingWindow.callBack2"
    />

    <!-- 抄录费用弹窗 -->
    <copy-charge-dialog
      :visible.sync="copyChargeDialog.visible"
      :lob="copyChargeDialog.lob"
      :is-sea="copyChargeDialog.isSea"
      :receivable="copyChargeDialog.receivable"
      :receivable-disable="copyChargeDialog.receivableDisable"
      :job="job"
      @selectedCopyChargeHandler="copyChargeRollBack"
    />

    <!-- 费用方案导入弹窗  -->
    <charge-scheme-batch-dialog
      :visible.sync="chargePlanDialog.visible"
      :lob="chargePlanDialog.lob"
      :is-sea="chargePlanDialog.isSea"
      :original-condition="chargePlanDialog.originalCondition"
      :charge-scheme-is-approved="chargePlanDialog.chargeSchemeIsApproved"
      :source="chargePlanDialog.source"
      :job="job"
      :receivable="chargePlanDialog.receivable"
      :receivable-disable="chargePlanDialog.receivableDisable"
      @selectedSchemeHandler="schemeChargeRollBack"
    />

    <!--加入费用-->
    <join-charge-dialog
      v-if="joinChargeDialog.visible"
      ref="joinChargeDialog"
      :visible.sync="joinChargeDialog.visible"
      :search-item-module="'5042'"
      :default-conditions="joinChargeDialog"
      @addChargeCallBackEvent="joinChargeCallBackEvent"
    />

  </div>
</template>

<script>

import StrUtils from '@/utils/StrUtils'
import joinChargeDialog from '@/components/Cargo/Act/joinChargeDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cache, cacheName } from '@/utils/cacheManager'
import ApprovalCommentsAndBtns from '@/components/Cargo/Common/Wrokflow/approvalCommentsAndBtns'
import { APPLICATION_DIMENSION_BILL, MAKE_INVOICE_BILLING } from '@/class/cargo/model/parameters/WorkflowConstants'
import { jumpFinaceOrBusiness } from '@/components/Cargo/grid/routerAndPrintHelp'
import BatchCheckingWindow from '@/components/Cargo/Job/CheckingManager/BatchCheckingWindow.vue'
import * as BillingUtils from '@/class/cargo/model/utils/BillingUtils'
import { createBillingNoCharge, isReceivable } from '@/class/cargo/model/utils/ReconciliationUtils'
import CargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import NumInput from '@/components/Cargo/Common/NumInput.vue'
import { SETTLEMENT_TYPE_STATES } from '@/class/cargo/model/parameters/BillingConstants'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import * as InvoiceConstant from '@/class/cargo/model/parameters/InvoiceConstant'
import { CurrencyUtil } from '@/class/cargo/model/utils/CurrencyUtil'
import { getSettlementAgentsByCmpIdx } from '@/api/company'
import { getObjectByCache } from '@/utils/basicDataCache'
import { basicCacheKeys } from '@/utils/cacheConfig'
import { queryTitleByCpmIdx } from '@/api/partner/title'
import { getCustomer } from '@/api/partner/customer'
import { getBankAccountList } from '@/api/bankAccount'
import { getTitleBankList } from '@/api/partner/titleBank'
import { getContactList } from '@/api/partner/contact'
import LocalStorageUtilsNew from '@/utils/localStorageUtilsNew'
import * as ReconciliationUtils from '@/class/cargo/model/utils/ReconciliationUtils'
import * as BillingRateUtil from '@/class/cargo/model/utils/BillingRateUtil'
import * as RateUtil from '@/class/cargo/model/utils/RateUtil'
import ChargeUtils from '@/class/cargo/model/utils/ChargeUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import { Charge } from '@/class/model/act/Charge'
import { getGridSelected } from '@/utils/agGrid'
import { chargeItemCompatibleLanguage, multiply, sleep, stringToBool } from '@/utils/commonUtil'
import lodash from 'lodash'
import CopyChargeDialog from '@/views/cargo/v0/SeaExport/components/booking/copyChargeDialog'
import ChargeSchemeBatchDialog from '@/views/cargo/v0/SeaExport/components/booking/chargeSchemeBatchDialog.vue'
import DateUtils from '@/utils/dateUtils'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import { checkPartyBillingNoExist, saveBilling } from '@/api/clearing/billingNative'
import { loadCharges, saveChargesFunc } from '@/api/clearing/charge'
import { getLoading } from '@/utils/utilBaseElement'
import { SecurityUtil } from '@/class/cargo/model/utils/SecurityUtil'
import * as ChargeMeasure from '@/class/cargo/model/parameters/ChargeMeasure'
import { ChargeColumnUtil } from '@/class/cargo/model/utils/ChargeColumnUtil'
import * as CommonState from '@/class/cargo/model/parameters/CommonState'
import * as ChangeChargeConstant from '@/class/cargo/model/parameters/ChangeChargeConstant'

export default {
  name: 'OperateBillDialog',
  components: {
    ChargeSchemeBatchDialog,
    CopyChargeDialog,
    NumInput, CargoAdvanceSelect,
    BatchCheckingWindow,
    joinChargeDialog, // 加入费用弹窗
    ApprovalCommentsAndBtns
  },
  props: {
    visible: { type: Boolean, required: true },
    instructionCode: { type: String, default: 'domesticBills' },
    location: { type: String, required: false },
    needTips: { type: Boolean, default: false },
    showWhtTax: { type: Boolean, default: false },
    job: { type: Object, required: true }
  },
  data() {
    return {
      selectTypeNames: TYPE_NAMES,
      innerVisible: false,
      expandedGrid: false,
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridCommonTextareaEditor
        },
        getRowStyle: function(params) {
          const data = params.data
          if (data) {
            if (data.hasOwnProperty('chargeVerifiedAmount')) {
              return (data.chargeConfirmState > 0 || data.chargeVerifiedAmount !== 0) ? { background: '#999999' } : { background: 'white' }
            } else {
              return data.chargeConfirmState > 0 ? { background: '#999999' } : { background: 'white' }
            }
          }
        }
      },
      gridParams: {},
      gridApi: null,
      rowData: [],
      formParams: {
        // 账单详情页 相关信息数据(除账单以为的数据)
        sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
        sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
        sourceRate3Enable: true, // 第三行汇率是否可编辑，默认不可编辑}
        billingNoteContainInvoiceReques: 0, // 票开账单包含开票要求，开票时可以根据开票要求，直接开票
        goodsNames: [] // 发票增值税利率
      },
      batchCheckingWindow: {
        visible: false,
        jobs: [],
        checkNode: 0,
        callBack: null,
        callBack2: null,
        billDataList: []
      },
      MAKE_INVOICE_BILLING: MAKE_INVOICE_BILLING,
      APPLICATION_DIMENSION_BILL: APPLICATION_DIMENSION_BILL,
      SETTLEMENT_TYPE_STATES,
      invoiceGoodsName: {
        gridApi: null,
        rowData: [],
        gridParams: {},
        gridOptions: {
          rowHeight: 30,
          rowSelection: 'single',
          singleClickEdit: true,
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          frameworkComponents: {
            CargoAgGridAdvanceSelectEditor
          },
          defaultColDef: {
            filter: false
          }
        }
      },
      titleArray: [], // 开票抬头集合
      titleBankArray: [], // 开票抬头对应的开票银行,既开户银行集合
      settlementAgentArray: [], // 结算代理集合
      ourBankAccountArray: [], // 我司银行集
      sourceRate1Enable: true, // 第一行汇率是否可编辑，默认不可编辑
      sourceRate2Enable: true, // 第二行汇率是否可编辑，默认不可编辑
      sourceRate3Enable: true, // 第三行汇率是否可编辑，默认不可编辑
      isZh: this.$store.getters.language === 'zh',
      accountContactsArray: [], // 结算单位联系人
      config: {
        getHBLcWeight: false, // 应收计费重量是否取分单的计费重量
        chargeSchemeIsApproved: false, // 费用方案需是否审核后才能使用【费用方案页签使用】
        currentOfficeCharge: false, // 是否开启选择不同操作公司后费用结算公司为当前分公司
        eiTaxControlInterfaceName: '',
        newInvoiceTypesOfBilling: false,
        billingNoteContainInvoiceReques: 0,
        toExoSystemYGSH: false,
        arSettlementUnitOptional: false,
        judgmentOfBillCurrency: false,
        isSaveBillRate: false, // 是否使用账单汇率进行计算
        isSpecialExpenseEntryFunction: false,
        inputIncludingTaxUnitPrice: 0
      },
      privilege: {
        isCostAddChargeRole: this.$checkPermission(['button_Charge_costAddCharge']), // 应收费用新增权限
        isPayAddChargeRole: this.$checkPermission(['button_Charge_payAddCharge']), // 应付费用新增权限
        copyCharge: this.$checkPermission(['role_Charge_copyCharge']), // 抄录费用
        chargeProject: this.$checkPermission(['role_Charge_chargeProject']) // 费用方案(费用页签)
      },
      billing: {
        uuid: '',
        version: 1,
        billingNo: '',
        accountId: 0,
        settlementAgentId: 0,
        invoiceTitleUuid: '', // 开票抬头UUID
        titleBankUuid: '', // 开户银行UUID
        buyerAddress: '',
        buyerTaxAccount: '',
        buyerTelephone: '',
        buyerBank: '',
        buyerBankAccount: '',
        ar: false,
        arValue: '',
        canEditAr: false,
        bankAccountId: 0,
        inputDate: '',
        dueDate: '',
        billingType: '',
        currency: '',
        sourceCurrency1: '',
        sourceCurrency2: '',
        sourceCurrency3: '',
        sourceRate1: 0.0,
        sourceRate2: 0.0,
        sourceRate3: 0.0,
        amount1: 0.0,
        amount2: 0.0,
        amount3: 0.0,
        remark: '',
        invoiceDemand: '',
        state: 0,
        amount: 0.0,
        taxAmount: 0.0,
        title: '',
        bankAccount: '',
        taxFreeAmount: 0.0, // 不含税额虚拟字段，用于逻辑处理
        counterPartyBillingNo: '',
        chargeCurrency1: '',
        chargeCurrency2: '',
        chargeRate1: 0.0,
        chargeRate2: 0.0,
        billingGroupUuid: '',
        removedCharges: [], // 删除掉的费用
        updateCharges: [], // 更新的费用
        createCharges: [], // 新增的费用
        addCharges: [], // 新增的费用
        currentOfficeId: 0,
        createBillWay: 0,
        makeInvoiceType: 0,
        invoiceRemark: '',
        invoiceUsdRemark: '',
        remarkAddContent: '',
        detailMakeInvoice: 0,
        splitMakeInvoice: true
      },
      copyChargeDialog: {
        visible: false,
        isSea: false,
        receivable: null,
        receivableDisable: false,
        lob: 'SE'
      },
      chargePlanDialog: {
        visible: false,
        isSea: false,
        lob: 'SE',
        originalCondition: {},
        receivable: null,
        receivableDisable: false,
        source: 'operateBillDialog',
        chargeSchemeIsApproved: false // 费用方案需是否审核后才能使用【费用方案页签使用】
      },
      joinChargeDialog: {
        visible: false,
        // 点击加入费用按钮时传递的参数
        exceptKeys: [],
        hasBillPayment: -1,
        hasBilling: -1,
        oversea: -1,
        accountId: 0,
        settlementAgentId: 0,
        limitSettlementAgent: false,
        instructionCode: null
      },
      currentViewCacheData: { // 表格下拉等数据map缓存，为了解决 表格渲染卡顿问题
        chargeMeasureSet: [], // 费用单位
        currencySet: [], // 币种
        companyContactPersonMap: new Map(), // company对应的联系人map 缓存
        customerSettlementAgentMap: new Map(), // 结算对象关联的结算代理
        chargeItemSet: new Set()
      }
    }
  },
  computed: {
    total() {
      return this.rowData.length || 0
    },
    columnDefs() {
      const result = [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('CargoMsg.Cargo_AddTag'), field: 'uuid', width: 100,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(!params.value)
          }
        },
        {
          headerName: this.$t('Billing.billingJob_paymentType'),
          field: 'receivable',
          width: 200,
          valueFormatter: params => {
            return CommonState.getNameByCode(ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE, params.value ? 1 : 0)
          },
          editable: (params) => !params.data.uuid && this.billing.canEditAr,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            const staticOptions = [...ChangeChargeConstant.CHANGE_CHARGE_CHARGETYPE]
            return {
              selectProps: {
                tagValue: 'code',
                tagName: 'chineseName',
                staticOptions,
                filterable: true,
                filterTagNames: ['code', 'chineseName']
              }
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingJob_chargeItem'),
          field: 'chargeItemId',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeItem, 'itemId', params.value, 'zhName')
          },
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              staticOptions: [...this.currentViewCacheData.chargeItemSet],
              methodParams: { advance: true },
              tagValue: 'itemId',
              tagName: this.language === 'zh' ? 'zhName' : 'enName',
              filterable: true,
              filterTagNames: ['chargecode', 'enName', 'zhName', 'cnShortName', 'scaleCode', 'languageName'],
              filterType: 'global',
              customLabel: (item) => this.language === 'zh' ? `${item.zhName}[${item.enName}]` : `${item.enName}[${item.zhName}]`,
              showCustomLabelInOption: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.adChargeInfo_settleAccountsTo'), field: 'accountId', width: 180, hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_SettlementAgent'), field: 'settlementAgentId', width: 180, hide: true,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_Company, 'cmpIdx', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingJob_currency'),
          field: 'currency',
          width: 200,
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'code',
              staticOptions: [...this.currentViewCacheData.currencySet],
              filterable: true,
              filterTagNames: ['code']
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingForm_unit'),
          field: 'measure',
          width: 200,
          valueFormatter: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_ChargeUnit, 'code', params.value, 'chineseName')
          },
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              clearable: false,
              selectType: TYPE_NAMES.basic_data_ChargeUnit,
              tagValue: 'code',
              tagName: this.$store.getters.language === 'zh' ? 'chineseName' : 'englishName',
              filterable: true
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('FinanceManage.charge_unitPriceIncludeTax'),
          colId: 'unitPriceIncludeTax',
          field: 'unitPriceIncludeTax',
          width: 180,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return stringToBool(params.value) ? this.$t('SeaExport.Yes') : this.$t('SeaExport.No')
          },
          editable: (params) => !params.data.uuid && !!this.config.inputIncludingTaxUnitPrice,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              tagValue: 'code',
              tagName: 'value',
              staticOptions: [{ code: false, value: this.$t('SeaExport.No') }, { code: true, value: this.$t('SeaExport.Yes') }]
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingJob_taxIncludedPrice'),
          field: 'amount',
          width: 200,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingJob_taxExcludedPrice'),
          field: 'excludingTaxAmount',
          width: 200,
          valueFormatter: (params) => {
            if (!params.data && params.value === undefined) {
              return ''
            }
            return this.$numeral(params.value).format('0.00')
          },
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 2
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingJob_taxRate'),
          field: 'taxRate',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingJob_amount'),
          field: 'quantity',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingJob_unitPrice'),
          field: 'unitRate',
          width: 200,
          valueFormatter: (params) => {
            return this.$numeral(params.value).format('0.000')
          },
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              controls: false,
              precision: 3
            }
          },
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingJob_taxAmount'),
          field: 'taxAmount',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_remarks'),
          field: 'remarks',
          width: 200,
          editable: (params) => !params.data.uuid,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          onCellValueChanged: p => this.onCellChange(p)
        },
        {
          headerName: this.$t('Billing.billingCharge_businessNumber'), field: 'jobNo', width: 150,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'multi-router-and-print',
            attrs: params => {
              const data = params.data
              return {
                useRoute: true,
                usePrint: false,
                jumpMethod: value => {
                  jumpFinaceOrBusiness(this, value, '', data.branchId)
                  this.closeDialog()
                }
              }
            }
          }
        },
        {
          headerName: this.$t('Billing.billingJob_mblNo'),
          field: 'mbl',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingJob_vesselAndVoyageAndFlight'),
          field: 'vesselFlight',
          width: 200
        },
        {
          headerName: this.$t('Billing.billingCharge_sales'), field: 'sales', initialWidth: 200,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        },
        {
          headerName: this.$t('Billing.billingForm_collectAndPrepaidOrNot'),
          field: 'advance',
          width: 200,
          cellRenderer: (params) => {
            return ColumnUtils.booleanLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('CargoMsg.Cargo_GPExplain'), field: 'explainGp', width: 100
        }
      ]
      if (this.showWhtTax) {
        result.push(
          {
            headerName: this.$t('FinanceManage.charge_whtTaxRate'),
            field: 'whtTaxRate',
            width: 100,
            valueFormatter: (params) => {
              if (!params.data && params.value === undefined) {
                return ''
              }
              return this.$numeral(params.value).format('0.00')
            },
            editable: (params) => !params.data.uuid,
            cellEditor: 'CargoAgGridCommonInputEditor',
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                controls: false,
                precision: 2
              }
            },
            onCellValueChanged: p => this.onCellChange(p)
          },
          {
            headerName: this.$t('FinanceManage.charge_whtTaxAmount'),
            field: 'whtTaxLocalAmount',
            width: 100,
            valueFormatter: (params) => {
              return ColumnUtils.numberColumnLabelFunc(params.value, 2)
            }
          }
        )
      }
      return result
    },
    invoiceMakeTypes() {
      // CARGO-19406 国内账单创建账单时，当 发票类型 = 内部发票 时，发票种类可选项只有纸质发票
      if (!this.billing.uuid && this.billing.invoiceType === InvoiceConstant.BILLING_INVOICE_TYPE_INTERNAL.code) {
        return [InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE]
      } else {
        return InvoiceConstant.BILLING_INVOICE_CATEGORY
      }
    },
    invoiceTypes() {
      // CARGO-38028 发票种类为纸质发票时，发票类型不可选电子发票相关类型
      const ifPaperInvoiceOrNoMakeType = this.billing.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code || !this.billing.invoiceMakeType
      const ifSpecialInterface = this.config.eiTaxControlInterfaceName === 'BWJSY' || this.config.eiTaxControlInterfaceName === 'TAX_EASY_THREE_PLUS' || this.config.eiTaxControlInterfaceName === 'NUONUO' || this.config.toExoSystemYGSH
      if (this.config.newInvoiceTypesOfBilling && ifSpecialInterface) {
        return ifPaperInvoiceOrNoMakeType ? InvoiceConstant.BILLING_INVOICE_TYPES_CJ : InvoiceConstant.BILLING_INVOICE_TYPES_CJ_EI
      }
      if (this.config.newInvoiceTypesOfBilling) {
        return InvoiceConstant.BILLING_INVOICE_TYPES_CJ
      }
      if (ifSpecialInterface) {
        return ifPaperInvoiceOrNoMakeType ? InvoiceConstant.BILLING_INVOICE_TYPES : InvoiceConstant.BILLING_INVOICE_TYPES_EI
      }
      return InvoiceConstant.BILLING_INVOICE_TYPES
    },
    sourceRate1Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency1)
    },
    sourceRate2Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency2)
    },
    sourceRate3Precision() {
      return CurrencyUtil.getCurrencyRateDigits(this.billing.sourceCurrency3)
    },
    // 是否开启了账单预开票
    billingNoteContainInvoice() {
      return this.config.billingNoteContainInvoiceReques && this.billing.makeInvoiceType === 0
    },
    billingNoteContainInvoiceChannel() {
      return this.config.billingNoteContainInvoiceReques === 2
    },
    invoiceGoodsNameColumnDefs() {
      return [
        { headerName: 'CNY' + this.$t('CargoMsg.Cargo_Project'), field: 'goodsNameRmb', width: 120,
          editable: (params) => params.data.hasRmb,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            return {
              selectProps: {
                staticOptions: (this.formParams.goodsNames || []),
                clearable: false,
                filterable: true,
                tagName: 'goodsNameRMB',
                tagValue: 'goodsNameRMB'
              }
            }
          },
          onCellValueChanged: p => this.onGoodsCellChange(p)
        },
        { headerName: 'USD' + this.$t('CargoMsg.Cargo_Project'), field: 'goodsNameUsd', width: 120,
          editable: (params) => params.data.hasUsd,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: (params) => {
            return {
              selectProps: {
                staticOptions: (this.formParams.goodsNames || []),
                clearable: false,
                filterable: true,
                tagName: 'goodsNameUSD',
                tagValue: 'goodsNameUSD'
              }
            }
          },
          onCellValueChanged: p => this.onGoodsCellChange(p)
        },
        { headerName: this.$t('Invoice.billingJob_taxRate'), field: 'taxRate', width: 100,
          cellRendererFramework: 'agGridColumnEdit',
          custom: {
            tag: 'el-select',
            options: InvoiceConstant.INVOICE_GOODS_NAME_TAX_RATE2,
            optionField: {
              labelFunc: item => {
                return item.chineseName
              },
              value: 'code'
            }
          }
        }
      ]
    },
    accountDisable() {
      return !this.billing.accountId
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.init()
      }
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
      if (!newVal) {
        this.rowData = []
      }
    }
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.config.getHBLcWeight = parseInt(cache.config.get('GetHBLcWeight')) === 1
      this.config.eiTaxControlInterfaceName = String(cache.config.get('EITaxControlInterfaceName'))
      this.config.newInvoiceTypesOfBilling = Number(cache.config.get('newInvoiceTypesOfBilling')) === 1
      this.config.billingNoteContainInvoiceReques = Number(cache.config.get('BillingNoteContainInvoiceReques'))
      this.config.toExoSystemYGSH = String(cache.config.get('ToExoSystem')) === 'YGSH' // 阳光速航
      this.config.arSettlementUnitOptional = Number(cache.config.get('ArSettlementUnitOptional')) === 1
      this.config.judgmentOfBillCurrency = Number(cache.config.get('JudgmentOfBillCurrency')) === 0
      this.config.isSpecialExpenseEntryFunction = Number(cache.config.get('SpecialExpenseEntryFunction')) === 1
      this.config.currentOfficeCharge = parseInt(cache.config.get('CurrentOfficeCharge')) === 1
      this.config.chargeSchemeIsApproved = Number(cache.config.get('ChargeSchemeIsApproved')) === 1 // 费用方案需是否审核后才能使用【费用方案页签使用】
      this.config.isSaveBillRate = Number(cache.config.get('isSaveBillRate')) === 1
      this.config.inputIncludingTaxUnitPrice = parseInt(cache.config.get('InputIncludingTaxUnitPrice'))
      this.queryOurBankAccountList()
      this.billing = await createBillingNoCharge(true)
      this.formParams.sourceRate1Enable = true
      if (this.instructionCode === 'domesticPay') {
        this.billing.ar = false
        this.billing.arValue = '应付'
      } else if (this.instructionCode === 'domesticReceivable') {
        this.billing.ar = true
        this.billing.arValue = '应收'
      } else {
        this.billing.ar = true
        this.billing.arValue = '应收/应付'
        this.billing.canEditAr = true
      }
      this.initGridSpareData()
    },
    // 抄录费用
    copyChargeHandler() {
      if (this.privilege.copyCharge && !this.privilege.isCostAddChargeRole && !this.privilege.isPayAddChargeRole) {
        this.$message.warning(this.$t('Message.NoNewPermissionsForFees'))
        return
      }
      this.copyChargeDialog.isSea = this.job.lob === 'SE' || this.job.lob === 'SI'
      this.copyChargeDialog.lob = this.job.lob
      if (this.instructionCode === 'domesticPay') {
        this.copyChargeDialog.receivable = 0
        this.copyChargeDialog.receivableDisable = true
      } else if (this.instructionCode === 'domesticReceivable') {
        this.copyChargeDialog.receivable = 1
        this.copyChargeDialog.receivableDisable = true
      } else {
        this.copyChargeDialog.receivable = null
      }
      this.recalculateBilling()
      this.copyChargeDialog.visible = true
    },
    // 抄录费用 选择费用后事件
    async copyChargeRollBack(chargeList) {
      const localCurrency = await RateUtil.localCurrencyByOffice()
      this.copyedChargeList = []
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      for (const charge of chargeList) {
        const obj = new Charge().fillDefaultValue().getData()
        obj.jobUuid = this.job.uuid
        // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (!chargeItem || !chargeItem.active) {
          haveDisableItem = true
          continue
        }
        // 特殊费用
        if (this.config.isSpecialExpenseEntryFunction) {
          if (chargeItem && chargeItem.specialExpenseMarker) {
            charge.chargeItemId = 0
          }
        }
        obj.chargeItemId = charge.chargeItemId
        obj.unitPriceIncludeTax = charge.unitPriceIncludeTax
        obj.accountId = this.billing.accountId
        obj.settlementAgentId = this.billing.settlementAgentId
        obj.invoiceTitle = this.billing.title
        obj.inputBy = this.$store.getters.userId
        obj.inputDate = DateUtils.formatStandardDateTime(new Date())
        obj.oversea = charge.oversea
        obj.currency = charge.currency
        obj.measure = charge.measure
        obj.receivable = charge.receivable
        obj.quantity = charge.quantity
        obj.unitRate = charge.unitRate
        obj.taxRate = charge.taxRate
        if (obj.unitPriceIncludeTax) {
          ChargeUtils.calculateTaxAmount(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
        } else {
          ChargeUtils.calculateTax(obj, multiply(obj.quantity, obj.unitRate), obj.taxRate)
        }
        obj.verifiedAmount = 0
        obj.accountingDate = null
        obj.counterPartyBillingNo = null
        obj.branchId = this.billing.branchId
        obj.inputByDep = this.job.opDepartment
        obj.businessDate = this.job.businessDate
        obj.localCurrency = localCurrency
        obj.exchangeRate = await RateUtil.getForeignExchangeRateByJob(localCurrency, obj.currency, this.job, obj.branchId)
        // HQ币种/汇率
        obj.hqCurrency = RateUtil.getHqCurrency(obj.branchId)
        obj.hqRate = await RateUtil.getForeignExchangeRateByJob(obj.hqCurrency, localCurrency, this.job, obj.branchId)
        obj.jobNo = this.job.jobNo
        obj.mbl = this.job.mbl
        obj.sales = this.job.sales
        obj.vesselFlight = this.job.vessel + ' ' + this.job.voyageFlight
        obj.chargeSource = this.chargeSource
        this.rowData.push(obj)
      }
      // 抄录的有禁用的收费项目提示
      if (haveDisableItem) {
        this.$message.warning(this.$t('Message.Some_Items_Have_Expired'))
        await sleep(100)
      }
      await this.refreshBilling()
    },
    // 费用方案
    schemeBillChargeEvent() {
      this.chargePlanDialog.isSea = this.job.lob === 'SE' || this.job.lob === 'SI'
      this.chargePlanDialog.lob = this.job.lob
      this.chargePlanDialog.chargeSchemeIsApproved = this.config.chargeSchemeIsApproved
      this.recalculateBilling()
      if (this.instructionCode === 'domesticPay') {
        this.chargePlanDialog.receivable = 0
        this.chargePlanDialog.receivableDisable = true
      } else if (this.instructionCode === 'domesticReceivable') {
        this.chargePlanDialog.receivable = 1
        this.chargePlanDialog.receivableDisable = true
      } else {
        this.chargePlanDialog.receivable = null
      }
      this.chargePlanDialog.visible = true
    },
    // 费用方案 选择费用后事件
    async schemeChargeRollBack(schemeDetails) {
      const charges = await ChargeUtils.applyChargeScheme(this.job, schemeDetails, 0, this.config.getHBLcWeight, this.billing.branchId)
      // 是否有禁用的收费项目标识
      let haveDisableItem = false
      for (const charge of charges) {
        charge.jobUuid = this.job.uuid
        charge.branchId = this.billing.branchId
        charge.accountId = this.billing.accountId
        charge.settlementAgentId = this.billing.settlementAgentId
        charge.invoiceTitle = this.billing.title
        charge.jobNo = this.job.jobNo
        charge.mbl = this.job.mbl
        charge.sales = this.job.sales
        charge.vesselFlight = this.job.vessel + ' ' + this.job.voyageFlight
        // 判断费用项目是否被禁用，若被禁用，不在进行抄录并提醒
        const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', charge.chargeItemId)
        if (!chargeItem || !chargeItem.active) {
          haveDisableItem = true
          continue
        }
        // 特殊费用
        if (this.config.isSpecialExpenseEntryFunction) {
          if (chargeItem && chargeItem.specialExpenseMarker) {
            charge.chargeItemId = 0
          }
        }
        this.rowData.push(charge)
      }
      // 抄录的有禁用的收费项目提示
      if (haveDisableItem) {
        this.$message.warning(this.$t('Message.Some_Items_Have_Expired'))
        await sleep(100)
      }
      await this.refreshBilling()
    },
    // 新增费用
    async addBillChargeEvent() {
      const charge = new Charge().fillDefaultValue().getData() // new Charge();
      charge.accountId = this.billing.accountId
      charge.branchId = this.billing.branchId
      charge.jobUuid = this.job.uuid
      charge.settlementAgentId = this.billing.settlementAgentId
      charge.receivable = this.billing.ar
      charge.invoiceTitle = this.billing.title
      charge.jobNo = this.job.jobNo
      charge.mbl = this.job.mbl
      charge.sales = this.job.sales
      charge.vesselFlight = this.job.vessel + ' ' + this.job.voyageFlight
      charge.unitPriceIncludeTax = this.config.inputIncludingTaxUnitPrice === 2
      this.rowData.push(charge)
      await this.refreshBilling()
    },
    // 加入费用
    joinBillChargeEvent() {
      if (!this.billing.accountId) {
        this.$message.warning(this.$t('CargoMsg.Cargo_PleaseSelectSettlingParty'))
        return
      }
      const charges = this.rowData
      const exceptKeys = []
      if (charges && charges.length > 0) {
        for (let i = 0; i < charges.length; i++) {
          const charge = charges[i]
          const key = charge['uuid']
          if (exceptKeys.indexOf(key) < 0) {
            exceptKeys.push(key)
          }
        }
      }
      this.joinChargeDialog.oversea = this.billing.billingType === 0
      this.joinChargeDialog.accountId = this.billing.accountId
      this.joinChargeDialog.hasBilling = 0
      this.joinChargeDialog.exceptKeys = exceptKeys
      this.joinChargeDialog.settlementAgentId = this.billing.settlementAgentId
      this.joinChargeDialog.limitSettlementAgent = true
      this.joinChargeDialog.instructionCode = this.instructionCode
      // 账单所属分公司
      this.joinChargeDialog.currentBillingBranchId = this.billing.branchId
      // 费用创建人同组
      let roleCreatedBy = []
      if (this.departmentTeamUser != null) {
        roleCreatedBy = [... this.departmentTeamUser]
      }
      roleCreatedBy.push(this.$store.getters.userId)
      this.joinChargeDialog.roleCreatedBy = roleCreatedBy
      this.recalculateBilling()
      // this.$refs.joinChargeDialog.receivableSearchItem()
      this.joinChargeDialog.visible = true
    },
    // 加入费用回调事件
    async joinChargeCallBackEvent(charges) {
      this.joinChargeDialog.visible = false
      const billing = this.billing
      if (charges && charges.length > 0) {
        for (const charge of charges) {
          const obj = new Charge().fillDefaultValue().getData()
          obj.uuid = charge.uuid
          obj.jobUuid = charge.jobUuid
          obj.chargeItemId = charge.chargeChargeItemId
          obj.unitPriceIncludeTax = charge.unitPriceIncludeTax
          obj.accountId = charge.chargeAccountId
          obj.settlementAgentId = charge.chargeSettlementAgentId
          obj.inputBy = charge.chargeInputBy
          obj.inputDate = charge.chargeInputDate
          obj.oversea = charge.chargeOversea
          obj.currency = charge.chargeCurrency
          obj.measure = charge.chargeMeasure
          obj.receivable = charge.chargeReceivable
          obj.quantity = charge.chargeQuantity
          obj.unitRate = charge.chargeUnitRate
          obj.taxRate = charge.chargeTaxRate
          obj.taxAmount = charge.chargeTaxAmount
          obj.excludingTaxAmount = charge.chargeExcludingTaxAmount
          obj.amount = charge.chargeAmount
          obj.verifiedAmount = charge.chargeVerifiedAmount
          obj.accountingDate = charge.chargeAccountingDate
          obj.branchId = charge.chargeBranchId
          obj.businessDate = charge.chargeBusinessDate
          obj.exchangeRate = charge.chargeExchangeRate
          obj.avance = charge.chargeAdvance
          obj.jobNo = charge.jobJobNo
          obj.mbl = charge.jobMbl
          obj.sales = charge.jobSales
          obj.whtTaxRate = charge.whtTaxRate
          obj.whtTaxLocalAmount = charge.whtTaxLocalAmount
          obj.remarks = charge.chargeRemarks
          obj.vesselFlight = charge.jobVesselFlight
          obj.version = charge.version
          this.rowData.push(obj)
        }
        // 国内账单，如果满足，则重新计算账单的收支类型
        billing.ar = isReceivable(this.rowData, billing.makeBillingPaymentReceiveMethod)
        await this.refreshBilling()
      }
      if (this.config.billingNoteContainInvoiceReques) {
        await BillingUtils.setBillingInvoiceInformation(this.billing, this.rowData)
      }
    },
    // 移除费用
    async removeBillChargeEvent() {
      const chooseRows = getGridSelected(this.gridOptions)
      for (let i = 0; i < chooseRows.length; i++) {
        const selectItem = chooseRows[i]
        const index = this.rowData.indexOf(selectItem)
        if (index > -1) {
          this.rowData.splice(index, 1)
        }
      }
      // 重算账单金额
      this.recalculateBilling()
      // 刷新费用列表数据
      this.refreshRowData()
      // 刷新账单
      await this.refreshBilling()
    },
    // 账单币种修改事件
    async currencyChangeEvent(obj) {
      this.updateBillingRate()
      if (obj) {
        const billing = this.billing
        billing.currency = obj.value
        const currency = billing.currency
        const sourceCurrency1 = billing.sourceCurrency1
        const sourceCurrency2 = billing.sourceCurrency2
        const sourceCurrency3 = billing.sourceCurrency3
        if (sourceCurrency1) {
          if (sourceCurrency1 !== currency) {
            // 不同币种做账单，如果找不到汇率则不能进行编辑汇率
            let rate = 0
            if (this.config.isSaveBillRate) {
              rate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency1, billing.inputDate, null, true)
            } else {
              rate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency1, billing.inputDate, billing.branchId, null, true)
            }
            billing.sourceRate1 = rate
            if (rate > 0) {
              this.formParams.sourceRate1Enable = false
            } else {
              this.formParams.sourceRate1Enable = true
            }
          } else { // 同币种做账单，汇率为1，此时汇率不可编辑
            billing.sourceRate1 = 1.0
            this.formParams.sourceRate1Enable = true
          }
        } else {
          billing.sourceRate1 = 0.0
          this.formParams.sourceRate1Enable = true
        }
        if (sourceCurrency2) {
          if (sourceCurrency2 !== currency) {
            // 不同币种做账单，如果找不到汇率则不能进行编辑汇率
            let rate = 0
            if (this.config.isSaveBillRate) {
              rate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency2, billing.inputDate, null, true)
            } else {
              rate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency2, billing.inputDate, billing.branchId, null, true)
            }
            billing.sourceRate2 = rate
            if (rate > 0) {
              this.formParams.sourceRate2Enable = false
            } else {
              this.formParams.sourceRate2Enable = true
            }
          } else { // 同币种做账单，汇率为1，此时汇率不可编辑
            billing.sourceRate2 = 1.0
            this.formParams.sourceRate2Enable = true
          }
        } else {
          billing.sourceRate2 = 0.0
          this.formParams.sourceRate2Enable = true
        }
        if (sourceCurrency3) {
          if (sourceCurrency3 !== currency) {
            // 不同币种做账单，如果找不到汇率则不能进行编辑汇率
            let rate = 0
            if (this.config.isSaveBillRate) {
              rate = await BillingRateUtil.getForeignExchangeRateByDate(currency, sourceCurrency3, billing.inputDate, null, true)
            } else {
              rate = await RateUtil.getForeignExchangeRateByDate(currency, sourceCurrency3, billing.inputDate, billing.branchId, null, true)
            }
            billing.sourceRate3 = rate
            if (rate > 0) {
              this.formParams.sourceRate3Enable = false
            } else {
              this.formParams.sourceRate3Enable = true
            }
          } else { // 同币种做账单，汇率为1，此时汇率不可编辑
            billing.sourceRate3 = 1.0
            this.formParams.sourceRate3Enable = true
          }
        } else {
          billing.sourceRate3 = 0.0
          this.formParams.sourceRate3Enable = true
        }
        await this.calculateAmount()
      }
    },
    // 更新账单汇率
    updateBillingRate() {
      const localCurrency = RateUtil.localCurrencyByOffice()
      if (this.config.isSaveBillRate) {
        this.billing.rate = BillingRateUtil.getForeignExchangeRateSafely(localCurrency, this.billing.currency, this.billing.inputDate)
      } else {
        this.billing.rate = RateUtil.getForeignExchangeRateSafely(localCurrency, this.billing.currency, this.billing.inputDate, this.$store.getters.currentOfficeId)
      }
      this.billing.rate = NumberUtils.roundHalfUp(this.billing.rate, 8) // CARGO-7779
    },
    // 刷新列表数据
    refreshRowData(chooseRows) {
      if (chooseRows && chooseRows.length > 0) {
        const rowData = this.rowData
        for (let i = 0; i < rowData.length; i++) {
          const rowItem = rowData[i]
          for (let j = 0; j < chooseRows.length; j++) {
            const selectedRow = chooseRows[j]
            if (this.reconciliationType === 'charge') {
              if (rowItem['uuid'] && selectedRow['uuid'] && rowItem['uuid'] === selectedRow['uuid']) {
                rowData[i] = selectedRow
                break
              }
            } else { // 按业务刷新列表时，jobUid为每一行的唯一标识
              if (rowItem['jobUid'] && selectedRow['jobUid'] && rowItem['jobUid'] === selectedRow['jobUid']) {
                rowData[i] = selectedRow
                break
              }
            }
          }
        }
        this.rowData = lodash.cloneDeep(rowData)
      }
    },
    // 重新计算账单金额，含税额以及分币种合计
    recalculateBilling() {
      ReconciliationUtils.sumBillingAmount(this.billing, this.rowData)
      ReconciliationUtils.groupCurrencyAmount(this.billing, this.rowData)
    },
    // 刷新帐单
    async refreshBilling() {
      await this.currencyChangeEvent(null)
      await this.fillChangedCurrency()
      await this.calculateAmount()
    },
    async fillChangedCurrency() {
      const billing = this.billing
      if (!billing) return
      const currencyMap = new Map()
      const charges = this.rowData
      if (charges && charges.length > 0) {
        for (let i = 0; i < charges.length > 0; i++) {
          const charge = charges[i]
          const currency = charge['currency']
          if (!currencyMap.has(currency)) {
            if (currency === billing.currency) {
              currencyMap.set(currency, 1.0)
            } else {
              let rate = NaN
              if (currency === billing.sourceCurrency1) {
                rate = billing.sourceRate1
              }
              if (currency === billing.sourceCurrency2) {
                rate = billing.sourceRate2
              }
              if (currency === billing.sourceCurrency3) {
                rate = billing.sourceRate3
              }
              if (!rate || !isNaN(rate)) {
                rate = await this.getRate(currency, billing)
              }
              currencyMap.set(currency, rate)
            }
          }
        }
      }
      // 先重置几个输入框
      let sourceCurrency1 = ''
      let sourceCurrency2 = ''
      let sourceCurrency3 = ''
      let sourceRate1 = 0.0
      let sourceRate2 = 0.0
      let sourceRate3 = 0.0
      let index = 1
      currencyMap.forEach(function(value, key) {
        if (index <= 3) {
          if (index === 1) {
            sourceCurrency1 = key
            sourceRate1 = value
          } else if (index === 2) {
            sourceCurrency2 = key
            sourceRate2 = value
          } else if (index === 3) {
            sourceCurrency3 = key
            sourceRate3 = value
          }
          index++
        }
      })
      if (sourceCurrency1) {
        billing.sourceRate1 = sourceRate1
        if (sourceRate1 > 0) {
          this.formParams.sourceRate1Enable = false
        } else {
          this.formParams.sourceRate1Enable = true
        }
      } else {
        billing.sourceRate1 = 0.00
        this.formParams.sourceRate1Enable = true
      }
      if (sourceCurrency2) {
        billing.sourceRate2 = sourceRate2
        if (sourceRate2 > 0) {
          this.formParams.sourceRate2Enable = false
        } else {
          this.formParams.sourceRate2Enable = true
        }
      } else {
        billing.sourceRate2 = 0.00
        this.formParams.sourceRate2Enable = true
      }
      if (sourceCurrency3) {
        billing.sourceRate3 = sourceRate3
        if (sourceRate3 > 0) {
          this.formParams.sourceRate3Enable = false
        } else {
          this.formParams.sourceRate3Enable = true
        }
      } else {
        billing.sourceRate3 = 0.00
        this.formParams.sourceRate3Enable = true
      }
      // 如果账单币种和原币种相同，则汇率不可编辑
      if (billing.currency === sourceCurrency1) {
        this.formParams.sourceRate1Enable = true
      }
      if (billing.currency === sourceCurrency2) {
        this.formParams.sourceRate2Enable = true
      }
      if (billing.currency === sourceCurrency3) {
        this.formParams.sourceRate3Enable = true
      }
      billing.sourceCurrency1 = sourceCurrency1
      billing.sourceCurrency2 = sourceCurrency2
      billing.sourceCurrency3 = sourceCurrency3
    },
    // 获取汇率
    async getRate(currency, billing) {
      let currencyRate = 0.00
      if (currency && billing) {
        const billingCurrency = billing.currency
        const sourceCurrency1 = billing.sourceCurrency1
        const sourceCurrency2 = billing.sourceCurrency2
        const sourceCurrency3 = billing.sourceCurrency3
        if (currency === billingCurrency) {
          currencyRate = 1.0
        } else {
          if (this.config.isSaveBillRate) {
            currencyRate = await BillingRateUtil.getForeignExchangeRateByDate(billingCurrency, currency, billing.inputDate, null, false)
          } else {
            currencyRate = await RateUtil.getForeignExchangeRateByDate(billingCurrency, currency, billing.inputDate, billing.branchId, null, false)
          }
          if (sourceCurrency1 && sourceCurrency1 === currency) {
            if (billing.sourceRate1) {
              currencyRate = billing.sourceRate1
            } else {
              billing.sourceRate1 = currencyRate
            }
            return currencyRate
          }
          if (sourceCurrency2 && sourceCurrency2 === currency) {
            if (billing.sourceRate2) {
              currencyRate = billing.sourceRate2
            } else {
              billing.sourceRate2 = currencyRate
            }
            return currencyRate
          }
          if (sourceCurrency3 && sourceCurrency3 === currency) {
            if (billing.sourceRate3) {
              currencyRate = billing.sourceRate3
            } else {
              billing.sourceRate3 = currencyRate
            }
            return currencyRate
          }
        }
      }
      return currencyRate
    },
    // 计算账单金额等属性
    async calculateAmount() {
      const billing = this.billing
      const sourceCurrency1 = billing.sourceCurrency1
      const sourceCurrency2 = billing.sourceCurrency2
      const sourceCurrency3 = billing.sourceCurrency3
      let billingAmount = 0.00// 账单金额
      let excludingTaxAmountTotal = 0.00// 税金
      let amount1 = 0.00
      let amount2 = 0.00
      let amount3 = 0.00
      const charges = this.rowData
      if (charges && charges.length > 0) {
        const zeroAmountCurrencys = ChargeUtils.getZeroAmountCurrencys(charges, 'currency', 'amount', 'receivable')
        for (let i = 0; i < charges.length > 0; i++) {
          const charge = charges[i]
          const chargeTaxAmount = charge.receivable ? charge.excludingTaxAmount : -charge.excludingTaxAmount
          const chargeAmount = isNaN(charge.amount) ? 0.00 : (charge.receivable ? charge.amount : -charge.amount)
          if (sourceCurrency1 && sourceCurrency1 === charge.currency) {
            amount1 += chargeAmount
          }
          if (sourceCurrency2 && sourceCurrency2 === charge.currency) {
            amount2 += chargeAmount
          }
          if (sourceCurrency3 && sourceCurrency3 === charge.currency) {
            amount3 += chargeAmount
          }
          if (zeroAmountCurrencys.includes(charge.currency)) continue
          const rate = await this.getRate(charge.currency, billing)
          // CARGO-25843，海运进出口涉及日币收费的费用计算方式更改
          billingAmount += NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(chargeAmount * rate, billing.currency), 2)
          excludingTaxAmountTotal += NumberUtils.ToFixed2(RateUtil.getAmountByCurrency(((isNaN(chargeTaxAmount) ? 0 : chargeTaxAmount) * rate), billing.currency), 2)
          billingAmount = RateUtil.getAmountByCurrency(billingAmount, billing.currency)
          excludingTaxAmountTotal = RateUtil.getAmountByCurrency(excludingTaxAmountTotal, billing.currency)
        }
      }
      if (this.instructionCode === 'domesticBills') {
        billing.ar = billingAmount >= 0
      }
      billing.amount = billing.ar ? billingAmount : -billingAmount
      billing.taxAmount = billing.ar ? NumberUtils.ToFixed2(RateUtil.getAmountByCurrency((billingAmount - excludingTaxAmountTotal), billing.currency), 2) : NumberUtils.ToFixed2(RateUtil.getAmountByCurrency((excludingTaxAmountTotal - billingAmount), billing.currency), 2)
      billing.taxFreeAmount = RateUtil.getAmountByCurrency(billing.amount - billing.taxAmount, billing.currency)
      billing.amount1 = billing.ar ? amount1 : -amount1
      billing.amount2 = billing.ar ? amount2 : -amount2
      billing.amount3 = billing.ar ? amount3 : -amount3
    },
    async saveBilling() {
      // 判断是否开启验证规则
      await cache.load(cacheName.CONFIG)
      const useCheckRule = Number(cache.config.get('useCheckRule')) === 1
      if (useCheckRule) {
        const checkNodeFlag = await JobUtils.hasCheckRuleCondition(true, CheckRuleConstants.NODE_SAVE_BILLING.code, this.$store.getters.currentOfficeId)
        if (checkNodeFlag) {
          this.batchCheckingWindow.checkNode = CheckRuleConstants.NODE_SAVE_BILLING.code
          this.rowData.forEach((item) => {
            item.lob = item.jobLob
            item.chargeUuid = item.uuid
            item.jobNo = item.jobJobNo
          })
          this.batchCheckingWindow.jobs = this.rowData
          this.batchCheckingWindow.lob = this.rowData[0].jobLob
          this.batchCheckingWindow.callBack = () => { this.saveBillingDetail() }
          this.batchCheckingWindow.callBack2 = null
          this.batchCheckingWindow.visible = true
        } else {
          await this.saveBillingDetail()
        }
      } else {
        await this.saveBillingDetail()
      }
    },
    // 保存账单
    async saveBillingDetail() {
      if (this.billing.counterPartyBillingNo) {
        const res = await checkPartyBillingNoExist({
          branchId: this.billing.branchId,
          billKey: this.billing.uuid,
          billingType: this.billing.billingType,
          counterPartyBillingNo: this.billing.counterPartyBillingNo
        })
        if (res.data) {
          const flag = await this.$confirm(this.$t('Billing.OppositeBillNoAlreadyExists'), this.$t('Message.Prompt'), {
            confirmButtonText: this.$t('common.btn.ok'),
            cancelButtonText: this.$t('common.btn.cancel'),
            dangerouslyUseHTMLString: true,
            closeOnClickModal: false,
            type: 'warning'
          }).then(() => true).catch(() => false)
          if (!flag) {
            return
          }
        }
      }
      if (this.formParams.billingNoteContainInvoiceReques && this.billing.remarkAddContent) {
        const r1 = this.billing.invoiceRemark.length
        const r2 = this.billing.remarkAddContent.length
        if (r1 + r2 > 230) {
          this.$message.warning(this.$t('CargoMsg.Cargo_RemarkTip1'))
          return
        }
      }
      // 校验开票抬头和结算代理
      const message = await this.checkAgentAndTitle()
      let isSave = true
      if (!StrUtils.isEmpty(message)) {
        isSave = false
        await this.$confirm(message, this.$t('Message.Prompt'), {
          confirmButtonText: this.$t('common.btn.ok'),
          cancelButtonText: this.$t('common.btn.cancel'),
          distinguishCancelAndClose: true,
          type: 'warning'
        }).then(() => {
          isSave = true
        }).catch(() => {})
      }
      if (isSave) {
        const billing = this.billing
        // 新增账单保存
        const passThrough = await this.validateBilling()
        if (passThrough) {
          let exec = true
          if (this.needTips) {
            await this.$confirm(this.$t('CargoMsg.Cargo_SureSaveBilling'), this.$t('Message.Tips'), {
              confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
              cancelButtonText: this.$t('CargoMsg.Cargo_No'),
              type: 'warning'
            }).then(() => {}).catch(() => {
              exec = false
            })
          }
          if (!exec) {
            return
          }
          billing.addCharges = this.rowData
          // CARGO-8145 【海运出口-海运订舱极速版】国内账单页签，缺少我司银行
          if (!billing.bankAccountId) {
            billing.bankAccountId = 0
          }
          this.loading = getLoading()
          billing.currentOfficeId = this.$store.getters.currentOfficeId
          billing.location = this.location
          if (billing.revoked && ((billing.addCharges && billing.addCharges.length > 0))) {
            billing.revoked = false
          }
          saveBilling(billing).then(res => {
            // 触发父级页面 重新加载
            this.$emit('reloadBillHandler')
            this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          }).catch().finally(() => {
            this.loading.close()
          })
        }
      }
    },
    // 校验开票抬头和结算代理是否一致提示
    checkAgentAndTitle() {
      const charges = this.rowData
      if (!charges || charges.length === 0) {
        return false
      }
      const sameTitle = ReconciliationUtils.isSameInvoiceTitle(charges)
      const sameSettlementAgent = ReconciliationUtils.isSameSettlementAgent(charges)
      let message = ''
      if (!sameTitle && !sameSettlementAgent) {
        message = this.$t('Message.SettlingAgentInvoiceTitleInconsistent')
      } else if (sameTitle && !sameSettlementAgent) {
        message = this.$t('Message.SettlingAgentInconsistent')
      } else if (!sameTitle && sameSettlementAgent) {
        message = this.$t('Message.TheTitleOfTheInvoiceIsInconsistentDoYouWantToContinue')
      }
      return message
    },

    // 校验账单
    async validateBilling() {
      const billing = this.billing
      const charges = this.rowData
      if (!charges || charges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseItemsCanTBeEmpty'))
        return false
      }
      if ((billing.sourceCurrency1 && !billing.sourceRate1) || (billing.sourceCurrency2 && !billing.sourceRate2) || (billing.sourceCurrency3 && !billing.sourceRate3)) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillRateEmpty'))
        return false
      }
      const keys = []
      const currencyArray = [] // 统计账单费用币种
      for (let i = 0; i < charges.length; i++) {
        const charge = charges[i]
        const key = charge['uuid']
        const currency = charge['currency']
        if (key && keys.indexOf(key) < 0) {
          keys.push(key)
        }
        if (currency && currencyArray.indexOf(currency) < 0) {
          currencyArray.push(currency)
        }
      }
      if (currencyArray.length > 3) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillCurrencyMore'))
        return false
      }
      // 是否允许多币种创建账单(参数只能在这里获取，原因是业务模块也会调用此方法)
      await cache.load(cacheName.CONFIG)
      if (!this.config.judgmentOfBillCurrency && currencyArray.length > 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrencyMustBeTheSame'))
        return false
      }
      let passThrough = true
      if (keys && keys.length > 0) {
        // 加载数据库中的费用，已此为验证标准
        const realCharges = await loadCharges({ chargeKeys: keys }).then(res => {
          return res.data
        }).finally(() => {})
        if (realCharges && realCharges.length > 0) {
          for (let i = 0; i < realCharges.length; i++) {
            const charge = realCharges[i]
            if (charge['offsetState'] === 1 || charge['offsetState'] === 2) {
              this.$message.warning(this.$t('CargoMsg.Cargo_OFTRFOTARFCBIITB'))
              passThrough = false
              break
            }
          }
          if (!passThrough) return passThrough
        }
        if (!realCharges || realCharges.length === 0) {
          this.$message.warning(this.$t('CargoMsg.Cargo_ExpenseItemsCanTBeEmpty'))
          return false
        }
      }
      for (let i = 0; i < charges.length; i++) {
        const charge = charges[i]
        if (charge['currency'] !== billing.currency) {
          let rate = 0
          if (this.config.isSaveBillRate) {
            rate = await BillingRateUtil.getForeignExchangeRateSafely(billing.currency, charge['currency'], billing.inputDate)
          } else {
            rate = await RateUtil.getForeignExchangeRateSafely(billing.currency, charge['currency'], billing.inputDate, billing.branchId)
          }
          if (isNaN(rate) || rate === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CERNM', [billing.currency]))
            passThrough = false
            break
          }
        }
      }
      if (!passThrough) return passThrough
      if (billing.ar && !billing.title) {
        this.$message.warning(this.$t('CargoMsg.Cargo_InvoicingHeadCannotBeEmpty'))
        return false
      }
      if (!billing.currency) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BillCurrencyEmpty'))
        return false
      }
      if (billing.settlementAgentId <= 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_SettlementAgentEmpty'))
        return false
      }
      let checkBranch = true
      for (let i = 0; i < charges.length; i++) {
        checkBranch = await SecurityUtil.checkChargeDetailBranch(charges[i].branchId)
        if (!checkBranch) {
          break
        }
      }
      if (!checkBranch) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CheckChargeDetailBranch'))
        return false
      }
      return true
    },
    async saveCharges() {
      const newCharges = []
      for (const item of this.rowData) {
        if (!item.uuid) {
          newCharges.push(item)
        }
      }
      if (newCharges.length === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NotFoundNeedSaveCharges'))
        return
      }
      let exec = true
      if (this.needTips) {
        await this.$confirm(this.$t('CargoMsg.Cargo_SureSaveChargeOnly'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {}).catch(() => {
          exec = false
        })
      }
      if (!exec) {
        return
      }
      this.loading = getLoading()
      saveChargesFunc(newCharges, this.location).then(res => {
        // 触发父级页面 重新加载
        this.$emit('reloadBillHandler')
        this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
      }).catch().finally(() => {
        this.loading.close()
      })
    },
    async closeDialog() {
      let exec = true
      if (this.needTips) {
        await this.$confirm(this.$t('CargoMsg.Cargo_SureCancelEdit'), this.$t('Message.Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Yes'),
          cancelButtonText: this.$t('CargoMsg.Cargo_No'),
          type: 'warning'
        }).then(() => {}).catch(() => {
          exec = false
        })
      }
      if (!exec) {
        return
      }
      this.innerVisible = false
    },
    // 选择结算对象
    async accountChange(p) {
      if (this.rowData && this.rowData.length > 0) {
        const oldAccountId = this.billing.accountId
        for (const item of this.rowData) {
          if (item.uuid && item.accountId !== p.value) {
            this.billing.accountId = 0
            const account = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.accountId)
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId)
            this.$message.warning(this.$t('CargoMsg.Cargo_JobBillingChargeNotEqual').format(item.jobNo, chargeItem ? chargeItem.zhName : ' ', account ? account.chineseName : ' '))
            this.$nextTick(() => {
              this.billing.accountId = oldAccountId
            })
            return
          }
        }
      }
      if (p.value) {
        this.billing.accountId = p.value
        let settlementAgentId = 0
        let settlementAgentArray = await getSettlementAgentsByCmpIdx(p.value).then((res) => { return res.data })
        if (settlementAgentArray && settlementAgentArray.length > 0) {
          const settlementAgent = settlementAgentArray[0]
          settlementAgentId = settlementAgent.cmpIdx
        } else {
          settlementAgentArray = []
          settlementAgentId = p.value
        }
        const account = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(p.value))
        if (settlementAgentArray.indexOf(account) < 0) {
          settlementAgentArray.push(account)
        }
        this.settlementAgentArray = settlementAgentArray
        this.billing.settlementAgentId = settlementAgentId
        for (const item of this.rowData) {
          item.accountId = this.billing.accountId
          item.settlementAgentId = this.billing.settlementAgentId
        }
        // 获取结算对象的开票抬头(如果旧值为0，说明是第一次初始化，将直接用传递进来的发票抬头)
        if (this.billing.title) {
          this.billing.title = this.billing.title.trim()
        }
        this.queryTitleList(p.value) // 一定要保证先查询开票抬头，然后再根据开票抬头去查询开票银行
        // 获取结算对象联系人
        this.queryAccountContact(this.billing.accountId)
      }
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 选择结算代理
    async settlementAgentChange(p) {
      if (this.rowData && this.rowData.length > 0) {
        const oldSettlementAgentId = this.billing.settlementAgentId
        for (const item of this.rowData) {
          if (item.uuid && item.settlementAgentId !== p.value) {
            this.billing.settlementAgentId = 0
            const settlementAgent = getObjectByCache(TYPE_NAMES.basic_data_Company, 'cmpIdx', item.settlementAgentId)
            const chargeItem = getObjectByCache(TYPE_NAMES.basic_data_ChargeItem, 'itemId', item.chargeItemId)
            this.$message.warning(this.$t('CargoMsg.Cargo_JobBillingChargeNotEqual').format(item.jobNo, chargeItem ? chargeItem.zhName : ' ', settlementAgent ? settlementAgent.chineseName : ' '))
            this.$nextTick(() => {
              this.billing.settlementAgentId = oldSettlementAgentId
            })
            return
          }
        }
      }
      if (p.value) {
        this.billing.settlementAgentId = p.value
        for (const item of this.rowData) {
          item.accountId = this.billing.accountId
          item.settlementAgentId = p.value
        }
      }
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
    },
    // 查询开票抬头
    queryTitleList(accountId) {
      queryTitleByCpmIdx(accountId).then((res) => {
        const billing = this.billing
        this.titleArray = res.data && res.data.length > 0 ? res.data : []
        let title = null
        if (this.titleArray && this.titleArray.length > 0) {
          for (let i = 0; i < this.titleArray.length; i++) {
            const item = this.titleArray[i]
            if (item.defaultTitle === true) {
              title = item
              break
            }
          }
          // 无默认抬头取第一条
          if (title == null) {
            title = this.titleArray[0]
          }
          billing.title = title.title
          billing.invoiceMakeType = title.invoiceMakeType
          billing.invoiceType = title.invoiceType
          billing.customerEmail = title.email || ''
          billing.invoiceTitleUuid = title.uuid
          billing.buyerTaxAccount = title.taxAccount
          billing.invoiceDemand = title.invoiceDemand || ''
        }
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', Number(billing.accountId))
        if (company) {
          getCustomer({ companyUuid: company.uuid }).then((res) => {
            const customer = res.data
            if (!billing.invoiceDemand && customer && customer.invoiceRemarks) {
              billing.invoiceDemand = customer.invoiceRemarks
            }
            billing.makeInvoiceType = customer.invoiceMode
          })
        }
        this.getTitleBankByTitle(title)
      })
    },
    // 查询当前分公司下的我司银行账号
    queryOurBankAccountList() {
      getBankAccountList(this.$store.getters.currentOfficeUuid).then((res) => {
        if (res.data && res.data.length > 0) {
          const ourBankAccountArray = res.data
          if (!this.billing.uuid) {
            // 新建账单时默认带出账单币种对应的默认银行,如果没有则随机去一条和账单币种相同的银行
            let isFind = false
            let bank = null
            for (let i = 0; i < ourBankAccountArray.length; i++) {
              const bankAccount = ourBankAccountArray[i]
              if (bankAccount['currency'] === this.billing.currency) {
                bank = bankAccount
                if (bankAccount['defaultPayment']) {
                  this.billing.bankAccountId = bankAccount['accountId']
                  this.billing.bankAccount = bankAccount['accountNo']
                  isFind = true
                  break
                }
              }
            }
            if (!isFind && bank) {
              this.billing.bankAccountId = bank['accountId']
              this.billing.bankAccount = bank['accountNo']
            }
          } else {
            for (let i = 0; i < ourBankAccountArray.length; i++) {
              const bankAccount = ourBankAccountArray[i]
              if (bankAccount['accountId'] === this.billing.bankAccountId) {
                this.billing.bankAccount = bankAccount['accountNo']
                break
              }
            }
          }
          this.ourBankAccountArray = ourBankAccountArray
        }
      })
    },
    // 开票抬头变更回调函数
    titleChangeEvent(item) {
      const billing = this.billing
      billing.invoiceTitleUuid = item.uuid
      billing.title = item.title
      billing.invoiceType = item.invoiceType
      billing.invoiceMakeType = item.invoiceMakeType
      if (item.invoiceDemand) {
        billing.invoiceDemand = item.invoiceDemand
      }
      billing.customerEmail = item.email || ''
      this.getTitleBankByTitle(item)
    },
    // 获取开票抬头所维护的开票银行
    async getTitleBankByTitle(title = null) {
      const billing = this.billing
      if (title) {
        billing.customerEmail = title.email || ''
        await getTitleBankList({ titleUuidList: [title.uuid] }).then((res) => {
          this.titleBankArray = res.data
          if (this.titleBankArray && this.titleBankArray.length > 0) {
            let bank = null
            for (let i = 0; i < this.titleBankArray.length; i++) {
              if (this.titleBankArray[i].defaultBank === true) {
                bank = this.titleBankArray[i]
                break
              }
            }
            if (bank === null) {
              bank = this.titleBankArray[0]
            }
            billing.titleBankUuid = bank.uuid
            billing.buyerBank = bank.bank
            billing.buyerBankAccount = bank.bankAccount
          } else {
            this.titleBankArray = []
            billing.titleBankUuid = ''
            billing.buyerBank = ''
            billing.buyerBankAccount = ''
          }
        })
        billing.buyerTaxAccount = title.taxAccount
        billing.buyerAddress = title.address
        billing.buyerTelephone = title.telephone
        if (!billing.invoiceDemand && title.invoiceDemand) {
          billing.invoiceDemand = title.invoiceDemand
        }
      } else {
        billing.buyerTaxAccount = ''
        billing.buyerAddress = ''
        billing.buyerTelephone = ''
        billing.buyerBank = ''
        billing.buyerBankAccount = ''
        billing.titleBankUuid = ''
        this.titleBankArray = []
      }
      this.setDefaultInvoiceContent()
    },
    // 开户银行回调事件
    getBankCusFromChild(obj) {
      this.billing.titleBankUuid = obj.uuid
      this.billing.buyerBank = obj.bank
      this.billing.buyerBankAccount = obj.bankAccount
    },
    // 我司银行账号下拉选择时,带出默认维护的银行账号
    getOurBankAccountFromChild(obj) {
      this.billing.bankAccountId = obj.accountId
      this.billing.bankAccount = obj.accountNo
    },
    // 修改我司银行
    changeOurBankByCurrency() {
      const ourBankAccountArray = this.ourBankAccountArray
      let isFind = false
      let bank = null
      for (let i = 0; i < ourBankAccountArray.length; i++) {
        const bankAccount = ourBankAccountArray[i]
        if (bankAccount.currency === this.billing.currency) {
          bank = bankAccount
          if (bankAccount.defaultPayment) {
            this.billing.bankAccountId = bankAccount.accountId
            this.billing.bankAccount = bankAccount.accountNo
            isFind = true
            break
          }
        }
      }
      if (!isFind) {
        if (bank) {
          this.billing.bankAccountId = bank.accountId
          this.billing.bankAccount = bank.accountNo
        } else {
          this.billing.bankAccountId = 0
          this.billing.bankAccount = ''
        }
      }
    },
    // 账单日期修改事件
    inputDateChange(p) {
      if (p.value) {
        this.billing.currency = p.value
        this.changeOurBankByCurrency()
      }
    },
    // 查询结算对象联系人
    queryAccountContact(accountId) {
      if (accountId > 0) {
        getContactList({ cmpIdx: accountId }).then((res) => {
          let contacts = []
          if (res.data && res.data.list.length > 0) {
            contacts = res.data.list
          }
          this.accountContactsArray = contacts
          if (contacts.length > 0) {
            if (!this.billing.uuid) { // 新增的时候，默认带出联系人信息
              for (const contact of contacts) {
                if (contact.defaultContact) {
                  this.billing.accountContacts = contact.contactPerson
                  this.billing.accountContactsTel = contact.telephone
                  break
                }
              }
            }
          }
        })
      }
    },
    // 结算单位联系人
    accountContactChangeEvent(contact) {
      if (contact) {
        this.billing.accountContacts = contact.contactPerson
        if (contact.hasOwnProperty('telephone')) {
          this.billing.accountContactsTel = contact.telephone
        }
      }
    },
    changeInvoiceMakeType() {
      const elInvoiceTypes = [InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT_DEDICATED.code, InvoiceConstant.BILLING_INVOICE_TYPE_EI_VAT.code]
      if (this.billing.invoiceMakeType === InvoiceConstant.BILLING_INVOICE_CATEGORY_PAPER_INVOICE.code && elInvoiceTypes.includes(this.billing.invoiceType)) {
        this.billing.invoiceType = ''
      }
    },
    /**
     * 获取账单关联的费用结算对象
     */
    getChargeAccounts() {
      if (!this.accounts || this.accounts.length <= 0) return []
      const accountMap = {}
      const accounts = []
      for (const accountId of this.accounts) {
        if (!accountId || accountMap[accountId]) {
          continue
        }
        accountMap[accountId] = true
        const company = getObjectByCache(basicCacheKeys.basic_data_Company, 'cmpIdx', accountId)
        if (company) {
          accounts.push(company)
        }
      }
      return accounts
    },
    async makeInvoiceTypeChange() {
      if (this.billing.makeInvoiceType === 0 && this.formParams.billingNoteContainInvoiceReques) {
        await BillingUtils.setBillingInvoiceInformation(this.billing, this.rowData)
      }
    },
    async detailMakeInvoiceChange() {
      if (!this.billing.detailMakeInvoice && this.formParams.billingNoteContainInvoiceReques) {
        await BillingUtils.setBillingInvoiceInformation(this.billing, this.rowData)
      }
    },
    // 列修改事件
    onGoodsCellChange(params) {
      const data = params.data
      const filed = params.colDef.field
      switch (filed) {
        case 'goodsNameRmb':
          data.goodsNameRmb = params.newValue
          break
        case 'goodsNameUsd':
          data.goodsNameUsd = params.newValue
          break
      }
    },
    // 默认开票信息
    setDefaultInvoiceContent() {
      if (!this.billing.uuid && (StrUtils.isEmpty(this.billing.invoiceMakeType) || StrUtils.isEmpty(this.billing.invoiceType)) &&
        LocalStorageUtilsNew.hasConfiguration('invoceByNewBilling')) {
        const item = LocalStorageUtilsNew.getConfiguration('invoceByNewBilling')
        if (item) {
          if (StrUtils.isEmpty(this.billing.invoiceMakeType)) this.billing.invoiceMakeType = item.invoiceMakeType || ''
          if (StrUtils.isEmpty(this.billing.invoiceType)) this.billing.invoiceType = item.invoiceType || ''
        }
      }
    },
    // 初始化列表所需的缓存数据
    async initGridSpareData() {
      this.initChargeMeasureSet()
      this.initCurrencySet()
      this.initChargeItemSet()
    },
    // 费用方案缓存数据
    initChargeMeasureSet() {
      const seaFreight = true
      const chargeMeasureSet = new Set()
      for (const item of ChargeMeasure.CHARGE_MEASURES) {
        if (item.forSeaFreight && seaFreight) {
          chargeMeasureSet.add(item)
        }
      }
      this.currentViewCacheData.chargeMeasureSet = Array.from(chargeMeasureSet)
    },
    // 币种缓存数据
    initCurrencySet() {
      const results = ColumnUtils.getBasicDataCacheList(TYPE_NAMES.basic_data_Currency)
      this.currentViewCacheData.currencySet = Array.from(new Set(results))
    },
    initChargeItemSet() {
      const results = chargeItemCompatibleLanguage()
      this.currentViewCacheData.chargeItemSet = new Set(results)
    },
    // 列修改事件
    async onCellChange(params) {
      let firstAccountId = false
      if (!params.oldValue) {
        firstAccountId = true
      }
      const newParams = {
        rowIndex: params.node.rowIndex,
        colId: params.column.colId,
        data: params.data,
        field: params.colDef.field,
        value: params.newValue,
        firstAccountId: firstAccountId,
        originalValue: params.oldValue
      }
      await this.chargeGridItemEditEndHandler(newParams)
      if (this.gridApi) {
        this.gridApi.refreshCells({ force: true })
      }
      await this.refreshBilling()
    },
    // 应收,应付用同一个事件
    async chargeGridItemEditEndHandler(params) {
      const charge = params.data
      switch (params.field) {
        case 'chargeItemId': {
          await ChargeColumnUtil.chargeItemChange(charge, params, true, this.job, this.currentViewCacheData, 1)
          charge.accountId = this.billing.accountId
          charge.settlementAgentId = this.billing.settlementAgentId
          charge.invoiceTitle = this.billing.title
          break
        }
        case 'measure': {
          await ChargeColumnUtil.changeChargeMeasureCombo(charge, params, this.job)
          break
        }
        case 'currency': {
          await ChargeColumnUtil.currencyChangeHandler(charge, this.job)
          break
        }
        case 'quantity': {
          await ChargeColumnUtil.quantityChange(charge, params)
          break
        }
        case 'unitRate': {
          await ChargeColumnUtil.unitRateChange(charge, params)
          break
        }
        case 'amount': {
          await ChargeColumnUtil.amountChange(charge, params)
          break
        }
        case 'excludingTaxAmount': {
          await ChargeColumnUtil.excludingTaxAmountChange(charge, params)
          break
        }
        case 'taxRate': {
          await ChargeColumnUtil.taxRateChange(charge, params)
          break
        }
        case 'unitPrice': {
          if (!charge.receivable) {
            const unitPriceData = params.value
            params.data.unitPrice = NumberUtils.formatNumber(NumberUtils.formatNumber(unitPriceData, 2))
          }
          break
        }
        case 'unitPriceIncludeTax': {
          await ChargeColumnUtil.unitPriceIncludeTaxChange(charge)
          break
        }
        case 'whtTaxRate': {
          charge.whtTaxRate = Number(params.value)
          break
        }
        default: {
          break
        }
      }
    }
  }
}
</script>

<style lang="scss">
#operateApp {
  &.bill-dialog {
    .bill-form-content{
      .el-col{
        margin-top: 0 !important;
        &.inline{
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          align-items: center;
          .el-form-item{
            flex: 1;
            &:last-of-type{
              /deep/ .el-form-item__label{
                text-indent: 10px;
              }
            }
          }
        }
      }
    }
    .el-dialog {
      display: flex;
      flex-direction: column;
      overflow: hidden;
    }
    .el-dialog__body{
      flex:1;
      overflow: scroll;
    }
    .el-scrollbar {
      &__view {
        display: flex;
        flex-direction: column;
      }
    }
    &-form-wrapper {
      .el-form-item__content {
        width: auto;
      }
    }
  }
}
</style>
